import urls from '../../app/urls';
import { unix } from '../../utils/datetime';
import request from '../../utils/request';
import { API } from '../shared/api-responses';
import { getAvatarURL } from './helpers';
import { CourseUserProfile } from './types';

export async function fetchCourseUserProfiles(
  bucket: string,
  courseId: string,
  payload: API.FetchCourseUserProfilesRequest
) {
  const transformedPayload: API.FetchCourseUserProfilesTransformedRequest = {
    avatarIds: Object.keys(payload.avatarIdAndCourseRoleDictionary),
    emailId: payload.isEmailIdNeeded ? 1 : 0,
    courseRole: payload.isCourseRoleNeeded ? 1 : 0,
  };

  const response = await request.post<API.FetchCourseUserProfilesResponse>(
    urls.getCourseUserProfiles,
    transformedPayload
  );

  const { userProfiles } = response.data;

  const transformedUserProfiles: Record<MongoId, CourseUserProfile> = {};

  for (const userProfile of userProfiles) {
    transformedUserProfiles[userProfile.avatarId] = {
      avatarId: userProfile.avatarId,
      avatarUrl: getAvatarURL(bucket, userProfile.avatarUrl),
      name: userProfile.name,
      emailId: userProfile.emailId,
      courseUserDetails: {},
      lastFetchedAt: unix(),
    };

    transformedUserProfiles[userProfile.avatarId].courseUserDetails = {
      ...transformedUserProfiles[userProfile.avatarId].courseUserDetails,
      [courseId]: {
        role:
          userProfile.courseRole ||
          payload.avatarIdAndCourseRoleDictionary[userProfile.avatarId] ||
          undefined,
        isRemovedMember: userProfile.isRemoved === 1,
      },
    };
  }

  return transformedUserProfiles;
}
